import { render, staticRenderFns } from "./Proveedor.vue?vue&type=template&id=e0c5292a"
import script from "./Proveedor.vue?vue&type=script&lang=js"
export * from "./Proveedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_vue-template-compiler@2.7.14_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports